const APPLE_PAY_BUTTON_ID = "st-apple-pay";
const APPLE_PAY_BUTTON_ATTRIBUTE = "data-apple-pay-button";

export { APPLE_PAY_BUTTON_ID, APPLE_PAY_BUTTON_ATTRIBUTE };
